<template>
	<div>
        <div class="upload-instruction-area">
            <p><b>Instruction:</b></p>
            <p>{{video_upload_instruction}}</p>

            <div v-if="user_has_video">
                <div v-for="(document, index) in user_data.documents">
                    <div v-if="document.document_type == 'stage2video'">
                        <video width="100%" height="300" controls>
                            <source v-bind:src="$socket.url+'/public/'+document.link">
                        </video>
                    </div>
                </div>
            </div>
                
            <form v-on:submit.prevent="uploadVideo" v-else>
                <input type="hidden" name="applicant_id" v-bind:value="user_data.id" />
                <input type="hidden" name="csrf" v-bind:value="user_data.id" />
                <div class="form-group">
                    <label for="upload_video" class="btn btn-success btn-outline-success" v-on:click="updateProgress"><i class="icofont icofont-video"></i>Upload Video</label>
                    <input type="file" name="video" accept=".mp4,.avi" id="upload_video" style="display: none;" required="required" ref="appVideo" v-on:change="videosSelected" />
                    <br />
                    <span class="label label-warning selected_video" v-if="video_selected != ''">{{video_selected}}</span>
                </div>
                <div class="form-group" v-show="parseInt(upload_progress) > 0">
                    <div class="progress">
                        <div class="progress-bar progress-bar-striped active" role="progressbar"
                        v-bind:aria-valuenow="upload_progress" aria-valuemin="0" aria-valuemax="100" v-bind:style="{width: upload_progress + '%'}">
                            {{upload_progress}}%
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <input type="submit" class="btn btn-primary btn-md" name="submit" />
                </div>
            </form>
                    
        </div>
        
	</div>
</template>

<style scoped>
    .upload-instruction-area{
        text-align: center;
        margin-top: 50px;
    }
    .upload-instruction-area p{
        font-size: 16px !important;
    }
    .selected_video{
        font-size: 14px !important;
        text-transform: none;
    }
</style>
<script>
import axios from 'axios'
import Vue from 'vue'

//create a new Vue instance for emiting data from Axios 
//upload event to our normal Vue instance.
const VI = new Vue()

export default{

	name: 'VideoUpload',
	data(){
        return{
            user_data: this.$store.getters.user_data.data,
            video_upload_instruction: '',
            file: '',
            upload_progress: 0,
            video_selected: ''
        }
    },
    mounted(){
        this.getVideoUplaodInfromation()

        console.log(this.$store.getters.user_data.data)
    },
    methods: {
        getVideoUplaodInfromation: function(){
            var iv = {
                what: 'InterviewVideo',
                id: this.user_data.joblisting_id
            }

            this.$socket.makeGetRequest(iv)
                .then((response)=>{
                    //console.log(response)
                    this.video_upload_instruction = response.data[0].instruction
                })
                .catch((error)=>{
                    this.video_upload_instruction = error.message
                    //this.$swal.fire('An error occured', error.message, 'error')
                    console.log(error)
                })
        },

        uploadVideo: function(){
            let url =  $socket.url + "/api/videoupload"
            this.file = this.$refs.appVideo.files[0]
            // console.log(this.file)

            var fd = new FormData()
            fd.append("video", this.file)
            fd.append("applicant_id", this.user_data.id)

            var config = {
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                onUploadProgress: function(event){
                    let loaded = event.loaded
                    let total = event.total

                    let perc = (loaded / total) * 100

                    perc = Math.round(perc)

                    //Emit event with Vue instance created
                    VI.$emit("upload_percent", perc)
                }
            }

            axios.post(url, fd, config)
                .then((response)=>{
                    //console.log(response)
                    if(response.data.status){
                        this.$swal.fire('Success', response.data.message + ". No further action for this stage is required. You will now be logged out.", 'success')

                        setTimeout(()=>{
                           this.$store.dispatch('logout')
                        }, 3000)
                    } else {
                        console.log(response)
                        this.$swal.fire('Error', response.data.message, 'error')
                    }
                })
                .catch((error)=>{
                    console.log(error)
                })
        },

        updateProgress: function(){

            //Listen for event
            VI.$on('upload_percent', (p)=>{
                this.upload_progress = p
            })
        },

        videosSelected: function(){
            this.video_selected = this.$refs.appVideo.files[0].name
        }
    },
    computed: {
        user_has_video: function(){
            var res = false

            for(var i=0;i<this.user_data.documents.length;i++){
                if(this.user_data.documents[i].document_type == 'stage2video'){
                    res = true
                }
            }

            return res


        }
    }
}
</script>